var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messages.length)?_c('div',{staticClass:"va-message-list",style:(_vm.computedStyle)},_vm._l((_vm.messages),function(message,index){return _c('div',{key:index,staticClass:"va-message-list__message"},[_vm._v(" "+_vm._s(message)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }